import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MessageService, MenuItem } from 'primeng/api';
import { BroadcastMessageService } from 'app/services';
import { Utils } from 'app/utils';
import moment from 'moment';

enum MenuTab {
    Details = 1,
    Message = 2
}

@Component({
    selector: 'broadcast-message-detail',
    templateUrl: './broadcast-message-detail.component.html',
    styleUrls: ['./broadcast-message-detail.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'
    ],
    providers: [MessageService]
})
export class BroadcastMessageDetailComponent implements OnInit {
    public broadcastMessageId: number = 0;
    @Input()
    set _broadcastMessageId(value: number) {
        this.broadcastMessageId = value;
    }

    @Input() public showBroadcastMessageDetailSideBar: boolean = false;

    constructor(private messageService: MessageService, private broadcastMessageService: BroadcastMessageService) {
    }

    @Output() changedShowBroadcastMessageDetailSideBarEmit = new EventEmitter<boolean>();
    changedShowBroadcastMessageDetailSideBar(increased: any) {
        this.changedShowBroadcastMessageDetailSideBarEmit.emit(increased);
    }

    public menuTab = MenuTab;
    public activeMenuTab: MenuTab = MenuTab.Details;
    public menuItems: MenuItem[] = [
        {
            label: 'Details',
            id: `${MenuTab.Details}`,
            command: (e: any) => this.handleTabChange(+e.item.id)
        },
        {
            label: 'Message',
            id: `${MenuTab.Message}`,
            command: (e: any) => this.handleTabChange(+e.item.id)
        }
    ];

    public loading: boolean = false;
    public broadcastMessage!: any;

    ngOnInit(): void {
        this.getDetailBroadcastMessage();
    }

    public handleTabChange(tab: MenuTab) {
        this.activeMenuTab = tab;
    }

    public getDetailBroadcastMessage() {
        this.loading = true;
        const dto = {
            Id: this.broadcastMessageId,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };
        this.broadcastMessageService.getDetailBroadcastMessage(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.loading = false;
                    return;
                }
                this.broadcastMessage = data;
                this.broadcastMessage.CreatedAt = moment(this.broadcastMessage.CreatedAt).format('DD MMM YYYY, hh:mmA');
                this.broadcastMessage.BroadcastStartDateTime = moment(this.broadcastMessage.BroadcastStartDateTime).format('DD MMM YYYY');
                this.loading = false;
            })
            .catch(error => {
                console.log(error);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
                this.loading = false;
            });
    }

    cancel() {
        this.changedShowBroadcastMessageDetailSideBar(false);
    }
}
